import $ from 'jquery';
import { tsibSearch } from 'craft-algolia-search';

/**
 * Algolia search.
 *
 * @author The Space In Between (sam@thespaceinbetween.co.nz)
 * @date 2019-02-04
 * @type {{init: AlgoliaSearch.init, configure: AlgoliaSearch.configure}}
 */
const AlgoliaSearch = {
    init: () => {
        tsibSearch.init({
            elements: {
                $form: $('#sib-search__form'),
                $more: $('#search__more'),
                $results: $('#sib-search__results'),
                $status: $('#sib-search__stats'),
                $title: $('#sib-search__title'),
            },
            log: false,
            result: {
                className: 'search-item'
            },
            pagination: {
                perPage: 10, // initial number of results to display and load/show more
            },
            templates: {
                // blankTitle: '<small>Enter a \'keyword\' to search</small>[]',
                // blankStatus: 'Enter a "keyword" to search',
                title: `There are {total} result{oneOrMany} for '{keyword}'`,
                titleEmpty: `We found no results for '{keyword}'`
            },
            type: 'ajax',
        });

    }

};

module.exports = AlgoliaSearch;



// WEBPACK FOOTER //
// ./src/js/partials/search.js